import React, { useEffect } from 'react';
import { components } from 'react-select';
import { useInView } from 'react-intersection-observer';

import {
  SelectProps,
  GroupBase,
  MenuListProps,
} from '../../types';

export type PaginatedSelectProps<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
> = SelectProps<Option, IsMulti, Group> & {
  onLoadMore?: () => void,
};

export function MenuListPaginated<
Option,
IsMulti extends boolean = false,
Group extends GroupBase<Option> = GroupBase<Option>,
>(props: MenuListProps<Option, IsMulti, Group> & { selectProps: PaginatedSelectProps<Option, IsMulti, Group> }) {
  const { ref, inView } = useInView();

  const childrensList = React.Children.toArray(props.children);
  const onLoadMore = props.selectProps.onLoadMore;

  useEffect(() => {
    if (props.options.length && inView && onLoadMore) {
      onLoadMore();
    }
  }, [props.options, inView, onLoadMore]);

  return (
    <components.MenuList {...props}>
      {childrensList.map((child, index) => {
        if (React.isValidElement(child) && child.props.innerProps) {
          delete child.props.innerProps.onMouseOver;
          delete child.props.innerProps.onMouseMove;
        }

        if (index === childrensList.length - 1) {
          return (
            <div
              key={index}
              ref={ref}
            >
              {child}
            </div>
          );
        }

        return child;
      })}
    </components.MenuList>
  );
}
